import React from 'react'
import Footer from '../Footer/Footer'
import Location from '../Dashboards/Location'
import HomeNav from '../Nav/HomeNav'

function Locationpge() {
  return (
    <div>
   <HomeNav/>

<div>
<Location></Location>
</div>
<Footer></Footer>


      
    </div>
  )
}

export default Locationpge
